import { MOCK_SUPPLIER_DATA } from './Enhancements/constants';

export default {
  data: {
    currTab: 'all',
    selectedSuppliers: [],
    selectedTags: [],
    filters: {
      countries: {
        field: 'countries',
        values: [''],
      },
      tags: {
        field: 'tags',
        values: [],
      },
      cities: {
        field: 'cities',
        values: [''],
      },
      productCategories: {
        field: 'productCatIds',
        values: [''],
      },
      auditCertifications: {
        field: 'auditCertTypeIds',
        values: [''],
      },
      topMarkets: {
        field: 'topMarket',
        values: [''],
      },
      keywords: {
        field: 'keyword',
        values: [''],
      },
    },
    messageSent: false,
  },
  status: 'editing',
  updateSuppliers: {
    loading: false,
    success: false,
    error: null,
  },
  supplierManagement: {
    search: '',
    searchBy: '',
    pagination: {
      total: 0,
      current: 0,
    },
    filter: {
      country: [],
      productCategory: [],
      status: [],
      rating: [],
    },
    sorter: {
      lastModified: 'asc', // "desc",
    },
    data: MOCK_SUPPLIER_DATA,
  },
  factoryManagement: {
    search: '',
    searchBy: '',
    pagination: {
      total: 0,
      current: 0,
    },
    filter: {
      country: [],
      auditCert: [],
    },
    sorter: {
      lastModified: 'asc', // "desc",
    },
    data: [],
  },
};
